// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer__footer___MMHBz{display:flex;justify-content:center;align-items:center;height:25px;flex-shrink:0;font-size:10px;font-weight:500;color:#717070;gap:20px}body.shop .footer__footer___MMHBz>div:first-child{display:none}body.shop .footer__footer___MMHBz:not(:has(button)){display:none}.footer__footerNavigation___dgKul{font-weight:500;display:flex;justify-content:space-around;align-items:center;cursor:pointer}.footer__icon___bbLQ5{width:18px;height:18px}.footer__itemContainer___i7b3T{display:flex;flex-direction:column;width:50%;align-items:center;justify-content:center;color:#717070;border-top:.5px solid #e9eff5;padding-top:10px;padding-bottom:5px;height:100%}.footer__itemContainer___i7b3T:hover{color:#27353b}.footer__highlighted___cJheK{border-top:2px solid #27353b;color:#27353b;background-color:#fff}.footer__chatContainer___j-p2I{position:relative;display:flex;gap:5px}.footer__unread___jaE1P{height:16px;width:16px;min-width:10px;background-color:red;text-align:center}.footer__footerContainer___\\+Vavx{margin-top:auto}html[dir=\"rtl\"] .footer__icon___bbLQ5{margin:0 0 0 10px;transform:scaleX(-1)}html[dir=\"rtl\"] .footer__chatContainer___j-p2I,html[dir=\"rtl\"] .footer__itemContainer___i7b3T{flex-direction:row-reverse}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#006cec",
	"primaryDarkerBlue": "#0047b9",
	"primarySlate": "#27353b",
	"borderPrimary": "#dce0e9",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "calc(100% - 30px)",
	"widgetFrameMaxHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"widgetMinWidth": "400px",
	"widgetMaxWidth": "720px",
	"footer": "footer__footer___MMHBz",
	"footerNavigation": "footer__footerNavigation___dgKul",
	"icon": "footer__icon___bbLQ5",
	"itemContainer": "footer__itemContainer___i7b3T",
	"highlighted": "footer__highlighted___cJheK",
	"chatContainer": "footer__chatContainer___j-p2I",
	"unread": "footer__unread___jaE1P",
	"footerContainer": "footer__footerContainer___+Vavx"
};
export default ___CSS_LOADER_EXPORT___;
